import { Type } from '@angular/core';
import { loadRemoteModule } from '@angular-architects/module-federation';
import { kebabToPascal } from './string-utils';

export function loadRemoteCdpModule(appName: string, remoteName?: string, moduleName?: string): Promise<Type<any>> {

  const pascalCaseModuleName = moduleName || kebabToPascal(`${appName}Module`);

  // module federation mode
  return loadRemoteModule({
    // TODO: use 'module' instead of 'script'
    type: 'module',
    // type: 'script',
    remoteEntry: `/app/${appName}/remoteEntry.js`,
    exposedModule: '.',
  })
    .then(m => m[pascalCaseModuleName])
    .catch(e => console.error(`failed to load remote module @cdp/${appName}`, e));
}
